import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from 'react-select';
import Dropdown from "react-bulma-dropdown";
import ReactPaginate from "react-paginate";
import { IoCloseCircleOutline, IoCreateSharp, IoPrint } from "react-icons/io5";
import { Link } from "react-router-dom";

const ServiceList = () => {
    const [services, setServices] = useState([]);
    const [page, setPage] = useState(0);
    const [limit] = useState(10);
    const [pages, setPages] = useState(0);
    const [rows, setRows] = useState(0);
    const [keywordcust, setKeywordCust] = useState("");
    const [querycust, setQueryCust] = useState("");
    const [keywordticket, setKeywordTicket] = useState("");
    const [queryticket, setQueryTicket] = useState("");
    const [selectcustomer, setSelectCustomer] = useState(null);
    const [optioncust, setOptionCust] = useState([]);
    const [msg, setMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '29px', // Adjust the minimum height of the control
      fontSize: '14px', // Adjust the font size
    }),
    valueContainer: (base) => ({
      ...base,
      height: '29px', // Set the specific height for the value container
      padding: '0 8px', // Adjust padding as needed
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: '0 4px', // Adjust padding for the clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '0 4px', // Adjust padding for the dropdown indicator
    }),
    menuList: (base) => ({
      ...base,
      fontSize: '14px', // Adjust the font size of the dropdown menu
    }),
  };

  const SmallSelect = (props) => (
    <Select styles={customStyles} {...props} />
  );

    const handleCustomerChange = (selectedOption) => {
        if (!selectedOption) {
        setQueryCust("");
        setSelectCustomer(null);
        setKeywordCust("");
        //console.error("Event or event target is null/undefined");
        return; // Exit the function gracefully
        }
        const newValue = selectedOption;
        setQueryCust(newValue.value);
        setSelectCustomer(newValue);
        console.log('Option selected:', newValue);
    };

    useEffect(() => {
        const fetchOptionCust = async () => {
            setIsLoading(true);
            try {
                // Replace with your actual Node.js API endpoint
                const resultcust = await axios.get(`${API_BASE_URL}/client`, {
                    headers: {
                        'X-API-Key': API_KEY
                    },
                }); 
                const datacust = resultcust.data;

                // Map the API data to the format react-select expects: { value: '', label: '' }
                const formattedOptionCust = datacust.map(item => ({
                    value: item.id,
                    label: item.name,
                }));

                setOptionCust(formattedOptionCust);
                setError(null);
            } catch (err) {
                setError('Failed to load options');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchOptionCust();
        getServices();
    }, [page, keywordcust, keywordticket]);

    const changePage = ({ selected }) => {
        setPage(selected);
        if (selected === 9) {
        setMsg(
            "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
        );
        } else {
        setMsg("");
        }
    };

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setMsg("");
        setKeywordCust(querycust);
        setKeywordTicket(queryticket);
    };

    const getServices = async () => {
        const response = await axios.get(`${API_BASE_URL}/services?search_customer=${keywordcust}&search_ticket=${keywordticket}&page=${page}&limit=${limit}`, {
            headers: {
                'X-API-Key': API_KEY
            },
        });
        setServices(response.data.result);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
    };

    const deleteService = async (serviceId) => {
        if (window.confirm('Are you sure you want to delete this item?')) {
            await axios.delete(`${API_BASE_URL}/services/${serviceId}`);
            getServices();
        } else {
            return
        }  
       
    };

    return (
        <div className="container">
            <h1 className="title is-size-5">Data Services</h1>
            <div className="columns">
                <div className="column is-9">
                    <form onSubmit={searchData}>
                        <div className="columns">
                            <div className="column is-6">
                                <div className="control">
                                    <SmallSelect
                                        value={selectcustomer}
                                        onChange={handleCustomerChange}
                                        options={optioncust}
                                        isLoading={isLoading}
                                        isClearable={true} 
                                        placeholder="Filter by customer..."
                                    />
                                </div>
                            </div>
                            
                            <div className="column is-4">
                                <div className="control">
                                    <input
                                    type="text"
                                    className="input is-small"
                                    value={queryticket}
                                    onChange={(e) => setQueryTicket(e.target.value)}
                                    placeholder="Filter by ticket id..." />
                                </div>
                            </div> 
                            <div className="column is-1">
                                <div className="control">
                                    <button type="submit" className="button is-small is-info">
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className="table-container">
                <table className="table is-striped is-fullwidth is-size-7">
                    <thead>
                    <tr>
                        <th>No</th>
                        <th className="has-text-centered">Actions</th>
                        <th>Service_Id</th>
                        <th>Ticket_Id</th>     
                        <th>Description</th>                   
                        <th>Product_Name</th>                        
                        <th>Customer</th>
                        <th>Contract_No</th>
                        <th>Repair_Status</th>
                        <th>Start_Time</th>
                        <th>End_Time</th>
                        <th>Technician</th>
                    </tr>
                    </thead>
                    <tbody>
                    {services.map((service, index) => (
                        <tr key={service.uuid}>                        
                        <td>{index + 1}</td>
                        <td className="has-text-centered">
                            <Dropdown trigger={<a className="button is-link is-small">Click Action</a>}>
                            {(service.repair_status!=="CLOSED") ?
                            <Link to={`/services/edit/${service.uuid}`} className="dropdown-item"><IoCreateSharp />&nbsp;Update Repair</Link> 
                            :
                            <p></p>
                            }
                            <Link to={`/services/detail/${service.uuid}`} className="dropdown-item"><IoPrint />&nbsp;Print Detail</Link>
                            <hr className="dropdown-divider" />
                            <a href="#" onClick={() => deleteService(service.uuid)} className="dropdown-item has-text-danger"><IoCloseCircleOutline />&nbsp;Delete</a>                     
                            </Dropdown>     
                        </td>
                        <td className="has-text-centered">{service.service_id}</td>
                        <td className="has-text-centered">{service.ticket.ticket_id}</td>                       
                        <td>{service.description}</td>
                        <td>{service.ticket.product.name}</td>
                        <td>{service.contract.client.name}</td>
                        <td className="has-text-centered">{service.contract.contract_no}</td>
                        <td className="has-text-centered has-text-weight-bold">
                            {(service.repair_status==="OPEN") ? 
                            <span className="tag is-danger">{service.repair_status}</span>
                            : (service.repair_status==="RECEIVED") ?
                            <span className="tag is-link">{service.repair_status}</span>
                            : (service.repair_status==="IN PROGRESS") ?
                            <span className="tag is-info">{service.repair_status}</span>
                            : (service.repair_status==="COMPLETED") ?
                            <span className="tag is-primary">{service.repair_status}</span>
                            : (service.repair_status==="RETURNED") ?
                            <span className="tag is-warning">{service.repair_status}</span>
                            : <span className="tag is-success">{service.repair_status}</span> }     
                        
                        </td>
                        <td className="has-text-centered">
                            {service.start_time ? (
                            new Date(service.start_time).toLocaleDateString('id', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: false,
                            })
                        ) : (
                            <p>-</p>
                        )}       
                        </td>
                        <td className="has-text-centered">
                            {service.end_time ? (
                            new Date(service.end_time).toLocaleDateString('id', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: false,
                            })
                        ) : (
                            <p>-</p>
                        )}
                                    
                        </td>
                        <td>{service.technician}</td>
                        
                    </tr>
                    ))}
                    </tbody>
                </table>
                <p className="is-size-7">
                Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
                </p>
                <p className="has-text-centered has-text-danger">{msg}</p>
                <nav
                    className="pagination is-centered is-size-7"
                    key={rows}
                    role="navigation"
                    aria-label="pagination"
                >
                    <ReactPaginate
                    breakLabel="..."
                    previousLabel={"< Prev"}
                    nextLabel={"Next >"}
                    pageCount={Math.min(10, pages)}
                    onPageChange={changePage}
                    containerClassName={"pagination-list"}
                    pageLinkClassName={"pagination-link"}
                    previousLinkClassName={"pagination-previous"}
                    nextLinkClassName={"pagination-next"}
                    activeLinkClassName={"pagination-link is-current"}
                    disabledLinkClassName={"pagination-link is-disabled"} />
                </nav>
            </div>
        </div>
    );
};

export default ServiceList;
